import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../config/api';

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    password: '',
    confirmPassword: '',
    address: '',
    grade: '',
    medium: 'Sinhala',
    district: '',
    schoolName: '',
    instituteName: 'ONLINE'
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    let value = e.target.value;
    if (e.target.name === 'phone') {
      // Allow only numbers
      value = value.replace(/[^0-9]/g, '');
      if (value.length > 10) value = value.slice(0, 10); // Optional: limit to 10 digits
    }
    setFormData({ ...formData, [e.target.name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(formData.password !== formData.confirmPassword) {
      setError("Passwords do not match!");
      return;
    }
    
    setError(null);
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/register.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok && data.status === 'success') {
        alert("Registration Successful! You can now log in.");
        navigate('/login');
      } else {
        setError(data.message || 'Registration failed.');
      }
    } catch (err) {
      setError('Network error. Ensure XAMPP Apache & MySQL are running.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-24 pb-12 bg-slate-50 flex items-center justify-center relative overflow-hidden">
      <div className="absolute top-[10%] left-[-10%] w-[40%] h-[40%] bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-blob"></div>
      <div className="absolute top-[30%] right-[-10%] w-[40%] h-[40%] bg-orange-200 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-blob animation-delay-2000"></div>
      <div className="absolute bottom-[-10%] left-[30%] w-[40%] h-[40%] bg-red-200 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-blob animation-delay-4000"></div>

      <div className="bg-white/80 backdrop-blur-xl border border-white p-8 md:p-12 rounded-[2.5rem] shadow-2xl w-full max-w-3xl relative z-10 mx-4">
        
        <div className="text-center mb-10">
          <Link to="/" className="inline-block mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center text-white font-bold text-3xl shadow-lg shadow-orange-200 mx-auto">
              K
            </div>
          </Link>
          <h2 className="text-4xl font-black text-slate-800 mb-2">Join the Academy</h2>
          <p className="text-slate-500 font-medium tracking-tight uppercase text-xs">Student Registration Portal</p>
        </div>

        {error && (
          <div className="mb-8 p-5 bg-red-50 border-l-4 border-red-500 text-red-600 rounded-r-xl text-sm font-bold shadow-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-10">
          
          {/* Section 1: Personal Information */}
          <div className="space-y-6">
             <div className="flex items-center gap-3">
                <div className="w-2 h-6 bg-orange-500 rounded-full"></div>
                <h3 className="text-lg font-bold text-slate-700">Personal Details</h3>
             </div>
             <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="md:col-span-2">
                   <InputField label="Full Name" name="fullName" value={formData.fullName} onChange={handleChange} placeholder="Kasun Walakumbura" required />
                </div>
                <InputField label="Phone Number" type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="07XXXXXXXX" required />
                <InputField 
                  label="District" 
                  type="select"
                  name="district" 
                  value={formData.district} 
                  onChange={handleChange} 
                  required 
                  options={['Ampara', 'Anuradhapura', 'Badulla', 'Batticaloa', 'Colombo', 'Galle', 'Gampaha', 'Hambantota', 'Jaffna', 'Kalutara', 'Kandy', 'Kegalle', 'Kilinochchi', 'Kurunegala', 'Mannar', 'Matale', 'Matara', 'Moneragala', 'Mullaitivu', 'Nuwara Eliya', 'Polonnaruwa', 'Puttalam', 'Ratnapura', 'Trincomalee', 'Vavuniya']}
                />
                <div className="md:col-span-2">
                   <InputField label="Home Address" name="address" value={formData.address} onChange={handleChange} placeholder="123, Main Road, City" required isTextArea />
                </div>
             </div>
          </div>

          {/* Section 2: Academic Information */}
          <div className="space-y-6">
             <div className="flex items-center gap-3">
                <div className="w-2 h-6 bg-blue-500 rounded-full"></div>
                <h3 className="text-lg font-bold text-slate-700">Academic Details</h3>
             </div>
             <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <InputField label="School Name" name="schoolName" value={formData.schoolName} onChange={handleChange} placeholder="e.g. Rahula College" required />
                <InputField 
                  label="Grade" 
                  type="select"
                  name="grade" 
                  value={formData.grade} 
                  onChange={handleChange} 
                  required 
                  options={['Grade 6', 'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12', 'Grade 13', 'Revision', 'Paper Class']}
                />
                <InputField 
                  label="Medium" 
                  type="select"
                  name="medium" 
                  value={formData.medium} 
                  onChange={handleChange} 
                  required 
                  options={['Sinhala', 'English']}
                />
             </div>
          </div>

          {/* Section 4: Security */}
          <div className="space-y-6">
             <div className="flex items-center gap-3">
                <div className="w-2 h-6 bg-red-500 rounded-full"></div>
                <h3 className="text-lg font-bold text-slate-700">Security</h3>
             </div>
             <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <InputField label="Password" type="password" name="password" value={formData.password} onChange={handleChange} placeholder="••••••••" required minLength={6} />
                <InputField label="Confirm Password" type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="••••••••" required minLength={6} />
             </div>
          </div>

          <div className="pt-6">
             <button
               type="submit"
               disabled={loading}
               className="w-full bg-gradient-to-r from-[#0f172a] to-[#334155] hover:from-orange-600 hover:to-red-600 text-white py-5 rounded-[2rem] font-black text-sm uppercase tracking-widest shadow-2xl shadow-slate-200 transition-all active:scale-[0.98] disabled:opacity-70 group"
             >
               {loading ? 'Processing Registration...' : 'Complete My Registration'}
             </button>
             <p className="text-center text-[11px] text-slate-400 font-bold uppercase tracking-widest mt-6">By signing up, you agree to our Terms and Conditions.</p>
          </div>
        </form>

        <div className="mt-12 text-center text-sm font-bold text-slate-500">
          Already have an account?{' '}
          <Link to="/login" className="text-orange-600 hover:text-orange-700 transition-colors underline decoration-2 underline-offset-4">
            Sign in here
          </Link>
        </div>
      </div>
    </div>
  );
};

const InputField = ({ label, name, value, onChange, placeholder, type = "text", required = false, minLength, isTextArea = false, options = [] }) => (
  <div>
    <label className="block text-[11px] font-black text-slate-400 uppercase tracking-[0.15em] mb-2 ml-1">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    {type === "select" ? (
      <select 
        name={name} 
        value={value} 
        onChange={onChange}
        required={required}
        className="w-full px-5 py-4 rounded-2xl bg-slate-50 border border-slate-100 focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all font-bold text-slate-700 text-sm appearance-none cursor-pointer"
      >
        <option value="">Select {label}</option>
        {options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
      </select>
    ) : isTextArea ? (
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        className="w-full px-5 py-4 rounded-2xl bg-slate-50 border border-slate-100 focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all placeholder-slate-300 font-bold text-slate-700 text-sm min-h-[100px]"
        placeholder={placeholder}
        required={required}
      />
    ) : (
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className="w-full px-5 py-4 rounded-2xl bg-slate-50 border border-slate-100 focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all placeholder-slate-300 font-bold text-slate-700 text-sm"
        placeholder={placeholder}
        required={required}
        minLength={minLength}
      />
    )}
  </div>
);

export default Register;
